import { Link } from 'react-router-dom'

// Per-kind recovery copy for the device-code confirm flow (#152). When
// LinkDevicePage hits an error from confirmDeviceCode, ErrorAlert shows the
// raw server message; this block adds tailored guidance + a help link so the
// user knows what to do next without filing a self-report.
//
// `kind` matches the `err.kind` set in lib/api.js#kindForStatus.
// `userCode` is echoed back so the user can re-paste it in Claude Desktop
// after regenerating (some kinds invalidate the code, others don't).
const COPY = {
  'session-expired': {
    label: 'Sign in again',
    body: 'Your sign-in session expired between opening this page and submitting. Sign in to next.actianlabs.com again, then return to this link.',
  },
  'code-not-found': {
    label: 'Generate a new code',
    body: 'That code is no longer pending. Open Claude Desktop and ask Claude to sign in again to generate a fresh code.',
  },
  'code-expired': {
    label: 'Generate a new code',
    body: 'The sign-in code expired (codes are valid for 10 minutes). Open Claude Desktop and ask Claude to sign in again.',
  },
  'already-confirmed': {
    label: 'Nothing more to do',
    body: 'This code was already confirmed by another browser tab or device. Return to Claude Desktop — the tool should work now.',
  },
  'server-error': {
    label: 'Try again in a moment',
    body: 'next-services is temporarily unreachable. Wait a minute and submit the form again. If it keeps failing, open a self-report.',
  },
  unknown: {
    label: 'Try again',
    body: 'Something unexpected happened. Try the form again, or generate a fresh code in Claude Desktop.',
  },
}

export default function RecoveryBlock({ kind, userCode }) {
  const copy = COPY[kind] || COPY.unknown
  return (
    <div
      role="status"
      className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700"
    >
      <p className="font-medium text-slate-900">{copy.label}</p>
      <p className="mt-1">{copy.body}</p>
      {userCode ? (
        <p className="mt-2 text-xs text-slate-500">
          Your code:{' '}
          <code className="rounded bg-white px-1.5 py-0.5 font-mono text-xs text-slate-700 ring-1 ring-slate-200">
            {userCode}
          </code>
        </p>
      ) : null}
      <Link
        to="/help/mcp-setup"
        className="mt-3 inline-flex min-h-[32px] items-center rounded-full border border-slate-300 bg-white px-3 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-100"
      >
        Read the setup guide
      </Link>
    </div>
  )
}
